import React, { useEffect, useState } from "react";
import { useApp } from "../../contexts";
import { FooterLogo } from "../Icons/FooterLogo";
import { Link, useLocation, useNavigate } from "react-router-dom";
import environment from "../../environment";
import { LINKTR_URLS, ZENDESK_URLS } from "../../constants";
import { ModalPolicy } from "../AffiliateComponent/ModalPolicy";
import useAffiliate from "../../hook/useAffiliate";

function Footer(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;

  const [linkHelp, $linkHelp] = useState(ZENDESK_URLS.EN.HELP);
  const [linkPolicy, $linkPolicy] = useState(ZENDESK_URLS.EN.PRIVACY_POLICY);
  const [termLink, setTermLink] = useState(ZENDESK_URLS.EN.TERMS_OF_USE);
  const [socialLink, $socialLink] = useState(LINKTR_URLS.EN);
  const { T, language, user } = useApp();
  const {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
  } = useAffiliate(); 

  useEffect(() => {
    const lan = language;
    if (lan === "ja") {
      $linkHelp(ZENDESK_URLS.JA.HELP);
      $linkPolicy(ZENDESK_URLS.JA.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.JA.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.JA);
    } else if (lan === "ko") {
      $linkHelp(ZENDESK_URLS.KO.HELP);
      $linkPolicy(ZENDESK_URLS.KO.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.KO.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.KO);
    } else if (lan === "cn") {
      $linkHelp(ZENDESK_URLS.CN.HELP);
      $linkPolicy(ZENDESK_URLS.CN.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.CN.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.CN);
    } else if (lan === "tc") {
      $linkHelp(ZENDESK_URLS.TC.HELP);
      $linkPolicy(ZENDESK_URLS.TC.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.TC.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.TC);
    } else if (lan === "vi") {
      $linkHelp(ZENDESK_URLS.VI.HELP);
      $linkPolicy(ZENDESK_URLS.VI.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.VI.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.VI);
    } else if (lan === "id") {
      $linkHelp(ZENDESK_URLS.ID.HELP);
      $linkPolicy(ZENDESK_URLS.ID.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.ID.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.ID);
    } else if (lan === "pt") {
      $linkHelp(ZENDESK_URLS.PT.HELP);
      $linkPolicy(ZENDESK_URLS.PT.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.PT.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.PT);
    } else if (lan === "es") {
      $linkHelp(ZENDESK_URLS.ES.HELP);
      $linkPolicy(ZENDESK_URLS.ES.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.ES.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.ES);
    } else {
      $linkHelp(ZENDESK_URLS.EN.HELP);
      $linkPolicy(ZENDESK_URLS.EN.PRIVACY_POLICY);
      setTermLink(ZENDESK_URLS.EN.TERMS_OF_USE);
      $socialLink(LINKTR_URLS.EN);
    }
  }, [language]);

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <footer
      className={`suzu-footer ${
        pathName.includes("/earner-detail") ? "!bg-white !mt-0" : ""
      }`}
    >
      <div className="footer-container">
        <div className="suzu-footer-row flex lg:flex-row-reverse suzu_flex_wrap lg:flex-nowrap item-center lg:mb-[20px]">
          <div className="footer-links flex item-center suzu_flex_wrap lg:flex-nowrap w-full lg:w-[65%] justify-between">
            <div className="footer-link-block w-[50%] lg:w-auto">
              <div className="footer-block-title">{T("AMS")}</div>
              <div className="footer-block-links">
                <div
                  className="color-[#00000099]"
                  onClick={() => navigateTo("/")}
                >
                  {T("Home")}
                </div>
                <Link to={"/wallet"}>
                  <div className="color-[#00000099]">{T("Wallet")}</div>
                </Link>

                <div
                  className="color-[#00000099]"
                  onClick={() => navigateTo("/asset")}
                >
                  {T("Asset")}
                </div>
              </div>
            </div>
            <div className="footer-link-block  w-[50%] lg:w-auto">
              <div className="footer-block-title">{T("Trade & Earn")}</div>
              <div className="footer-block-links">
                <div
                  className="color-[#00000099]"
                  onClick={() => navigateTo("/stake-for-option")}
                >
                  {T("Stake for option")}
                </div>
                <div
                  className="color-[#00000099]"
                  onClick={() => navigateTo("/stake")}
                >
                  {T("Stake for voting")}
                </div>
                <Link to={`${user.store_shopify}?lang=${user.language}`} target="_blank">
                  <div className="color-[#00000099]">{T("Mall")}</div>
                </Link>
                <Link
                  to={`${environment.MARKETPLACE_URL}/marketplace?lang=${language}`}
                  target="_blank"
                >
                  <div className="color-[#00000099]">{T("C2C market")}</div>
                </Link>
              </div>
            </div>
            <div className="footer-link-block  w-[50%] mt-[20px] lg:w-auto lg:mt-0">
              <div className="footer-block-title">{T("My Profile")}</div>
              <div className="footer-block-links">
                <div
                  onClick={() => navigateTo("/profile")}
                  className="color-[#00000099]"
                >
                  {T("My Profile")}
                </div>
                <div
                  className="color-[#00000099]"
                  onClick={() => navigateTo("/my-purchase")}
                >
                  {T("My Purchase")}
                </div>
                <div
                  className="color-[#00000099]"
                  onClick={() => onAffiliate()}
                >
                  {T("My Affiliate")}
                </div>
              </div>
            </div>
            <div className="footer-link-block  w-[50%] mt-[20px] lg:w-auto lg:mt-0">
              <div className="footer-block-title">{T("Resources")}</div>
              <div className="footer-block-links">
                <Link to={termLink} target="_blank">
                  <div className="color-[#00000099]">{T("Terms of use")}</div>
                </Link>
                <Link to={linkPolicy} target="_blank">
                  <div className="color-[#00000099]">{T("Privacy Policy")}</div>
                </Link>
                <Link to={linkHelp} target="_blank">
                  <div className="color-[#00000099]">{T("Help center")}</div>
                </Link>
                <Link to={socialLink} target="_blank">
                  <div className="color-[#00000099]">
                    {T("Social media & Community")}
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="company-block w-full lg:w-[35%] mb-[18px] lg:mb-[0]">
            <div className="footer-logo max-w-[237px] mt-[10px] lg:mt-0 mx-0 lg:mx-0 mb-[15px] cursor-pointer">
              <FooterLogo
                className="w-full"
                onClick={() => navigateTo("/")}
              />
            </div>
            <div className="flex justify-start items-center pb-[20px]">
              <Link
                to={"https://www.instagram.com/aiavatar_biz/"}
                target="_blank"
                className="cursor-pointer mr-[10px]"
              >
                <img src="/assets/images/icon-instagram.svg" alt=""/>
              </Link>
              <Link
                to="https://x.com/suzuverse_japan"
                target="_blank"
                className="cursor-pointer mx-[10px]"
              >
                <img src="/assets/images/icon-x.svg" alt=""/>
              </Link>
              <Link
                to={"https://line.me/R/ti/p/@769ztoek"}
                target="_blank"
                className="cursor-pointer mx-[10px]"
              >
                <img src="/assets/images/icon-line.svg" alt=""/>
              </Link>
              <Link
                to={"https://www.facebook.com/aiavatarjapan"}
                target="_blank"
                className="cursor-pointer mx-[10px]"
              >
                <img src="/assets/images/icon-facebook.svg" alt=""/>
              </Link>
              <Link
                to={"https://www.youtube.com/channel/UCTrSAg9bcBaCO6SVoRVPa5Q"}
                target="_blank"
                className="cursor-pointer mx-[10px]"
              >
                <img src="/assets/images/icon-youtube.svg" alt=""/>
              </Link>
            </div>
          </div>
        </div>
        <div
          className={
            "copy-right text-sm xl:text-base pb-[20px] tracking-[-0.5px]"
          }
        >
          {T("© 2025 AI Avatar Pte. Ltd. All rights reserved.")}
        </div>
      </div>

      {isOpenModalPolicy && (
        <ModalPolicy
          onClose={() => setIsOpenModalPolicy(false)}
          handleSubmit={() => onConfirmPolicy()}
        ></ModalPolicy>
      )}
    </footer>
  );
}

export default Footer;
